/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface Value
 */
export interface Value {
    /**
     * 
     * @type {number}
     * @memberof Value
     */
    valueNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof Value
     */
    valueString?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Value
     */
    valueBoolean?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Value
     */
    valueDateTime?: Date;
}

/**
 * Check if a given object implements the Value interface.
 */
export function instanceOfValue(value: object): boolean {
    return true;
}

export function ValueFromJSON(json: any): Value {
    return ValueFromJSONTyped(json, false);
}

export function ValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): Value {
    if (json == null) {
        return json;
    }
    return {
        
        'valueNumber': json['valueNumber'] == null ? undefined : json['valueNumber'],
        'valueString': json['valueString'] == null ? undefined : json['valueString'],
        'valueBoolean': json['valueBoolean'] == null ? undefined : json['valueBoolean'],
        'valueDateTime': json['valueDateTime'] == null ? undefined : (new Date(json['valueDateTime'])),
    };
}

export function ValueToJSON(value?: Value | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'valueNumber': value['valueNumber'],
        'valueString': value['valueString'],
        'valueBoolean': value['valueBoolean'],
        'valueDateTime': value['valueDateTime'] == null ? undefined : ((value['valueDateTime'] as any).toISOString()),
    };
}

